<template>
  <div id="uploadPdf">
    <el-upload
      class="upload-demo"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      action
      :http-request="uploadToOss"
      :multiple="multiple"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <!-- multiple -->
      <!-- :on-exceed 文件超出个数限制时的钩子 -->
      <el-button size="small" icon="el-icon-upload2">上传文件</el-button>
      <div slot="tip" class="el-upload__tip">支持.pdf格式</div>
    </el-upload>
    <el-progress
      v-if="progress && progress != 100"
      :text-inside="true"
      :stroke-width="15"
      :percentage="progress"
    ></el-progress>
  </div>
</template>

<script>
import OSS from "ali-oss";

// const client = new OSS({
//   region: "oss-cn-beijing",
//   accessKeyId: "LTAI4Fz8Bh5dvo8P6MDcHFTw",
//   accessKeySecret: "ibVikEYxXtEMrn7mVSxpsG26FK2Osy",
//   bucket: "mumu-pdf",
// });
const client = new OSS({
  region: "oss-accelerate",
  accessKeyId: "LTAI4Fz8Bh5dvo8P6MDcHFTw",
  accessKeySecret: "ibVikEYxXtEMrn7mVSxpsG26FK2Osy",
  bucket: "mumu-pdf",
});

export default {
  name: "uploadPdf",
  props: {
    valKey: Array,
    list: [Array, String],
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: [],
      multiple: false,
      limit: 1,
      progress: 0,
    };
  },
  watch: {
    list: {
      handler(newVal) {
        if (newVal && newVal.length) {
          let list = Array.isArray(newVal) ? newVal : [newVal];
          let newList = this.disposeFileFormat(list);
          this.fileList = newList;
        }
      },
      immediate: true,
      deep: false,
    },
    fileList: {
      handler(newFileList) {
        this.getUploadImgs(newFileList);
      },
      // immediate: true,
      deep: false,
    },
    valKey(newVal) {
      if (newVal) {
        if (newVal[2] === "string") {
          this.multiple = false;
          this.limit = 1;
        } else {
          this.multiple = true;
          this.limit = 100;
        }
      }
    },
  },
  methods: {
    // 处理文件格式
    disposeFileFormat(list) {
      let newList = list.map((item) => {
        return {
          name: item,
          url: item,
        };
      });
      return newList;
    },
    // 把数据处理成后台需要的urlList传给父组件 这里明天看完代码在写
    getUploadImgs(newFileList) {
      let imgs = [];
      if (newFileList.length) {
        imgs = newFileList.map((item) => {
          return item.url;
        });
      }
      this.$emit("get-files", imgs, this.valKey); // key : form 中对应字段
    },
    // 删除操作
    handleRemove(file, fileList) {
      let deleteIndex = this.fileList.findIndex((item) => {
        return item.uid === file.uid;
      });
      this.fileList.splice(deleteIndex, 1);
    },

    // 文件超出个数限制
    handleExceed(files, fileList) {
      this.$message.warning(
        // `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        //   files.length + fileList.length
        // } 个文件`
        "当前限制只能上传一个文件"
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    // 上传文件到oss
    uploadToOss(e) {
      let that = this;
      let file = e.file; // 文件信息
      if (!file) {
        return false;
      } else if (!/\.(pdf)$/.test(file.name.toLowerCase())) {
        // 格式根据自己需求定义
        this.$message.error("上传格式不正确，请上传pdf格式");
        return false;
      }

      let newFileName = this.generateFileName(file.name);
      client
        .multipartUpload(newFileName, file, {
          progress: function (p) {
            //p进度条的值
            that.showProgress = true;
            that.progress = Math.floor(p * 100);
          },
        })
        .then((result) => {
          let url = result.res.requestUrls[0].split("?uploadId")[0];
          that.fileList.push({
            name: result.name,
            url: this.replaceHttps(url),
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message.warning("上传超时，请重新上传");
        });
    },

    // 替换HTTPS
    replaceHttps(url) {
      return url.replace("http", "https");
    },

    generateFileName(fileName) {
      let namelist = fileName.split(".");
      let suffix = namelist[namelist.length - 1];
      namelist.splice(namelist.length - 1, 1);
      let name = namelist.join(".");

      let md5Name = this.$md5(`${name}${this.title}${Date.parse(new Date())}`);
      let newFileName = `${name}-${md5Name}.${suffix}`;

      return newFileName;
    },
  },
};
</script>
<style lang="scss" scoped>
#uploadPdf {
  /deep/ .el-upload-list {
    width: 70%;
  }
  /deep/ .el-progress-bar {
    width: 300px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/upload/uploadPdf.vue